// src/components/admin/SystemHealthPill.jsx  
import React, { useEffect, useState } from "react";  
import { motion } from "framer-motion";  
import api from "../../api";  
  
const SystemHealthPill = () => {  
  const [state, setState] = useState({ tone: "gray", label: "…", title: "" });  
  
  useEffect(() => {  
    let cancelled = false;  
  
    const check = async () => {  
      try {  
        const { data } = await api.get("/admin/system/health");  
        if (cancelled) return;  
  
        if (!data.ok) {  
          // Introspection failed — but bot_manager may well be running.  
          // Show neutral, not red.  
          setState({  
            tone: "gray",  
            label: "Live status unavailable",  
            title: data.detail || data.reason || "Bot manager introspection not available",  
          });  
          return;  
        }  
  
        const running = data.running_count ?? 0;  
        const deadTasks = (data.entry_tasks || []).filter((t) => t.done === true).length;  
  
        if (deadTasks > 0) {  
          setState({  
            tone: "amber",  
            label: `${deadTasks} dead task${deadTasks === 1 ? "" : "s"}`,  
            title: "Some asyncio tasks are done but still tracked",  
          });  
        } else {  
          setState({  
            tone: "green",  
            label: `${running} running`,  
            title: "All tracked tasks alive",  
          });  
        }  
      } catch (err) {  
        if (!cancelled) {  
          setState({  
            tone: "red",  
            label: "Health API error",  
            title: err.message,  
          });  
        }  
      }  
    };  
  
    check();  
    const id = setInterval(check, 30_000);  
    return () => { cancelled = true; clearInterval(id); };  
  }, []);  
  
  const tones = {  
    green: "bg-green-500/10 border-green-500/40 text-green-400",  
    amber: "bg-amber-500/10 border-amber-500/40 text-amber-300",  
    red:   "bg-red-500/10 border-red-500/40 text-red-400",  
    gray:  "bg-gray-500/10 border-gray-700 text-gray-400",  
  };  
  const dot = {  
    green: "bg-green-400 animate-pulse",  
    amber: "bg-amber-400",  
    red:   "bg-red-400",  
    gray:  "bg-gray-500",  
  }[state.tone];  
  
  return (  
    <motion.div  
      initial={{ opacity: 0 }} animate={{ opacity: 1 }}  
      title={state.title}  
      className={`hidden sm:inline-flex items-center gap-2 px-3 h-9 rounded-lg border text-[11px] font-semibold uppercase tracking-wider ${tones[state.tone]}`}  
    >  
      <span className={`w-2 h-2 rounded-full ${dot}`} />  
      {state.label}  
    </motion.div>  
  );  
};  
  
export default SystemHealthPill;  